module.exports = __webpack_public_path__ + "img/ic_verify_fail.0ba5f26b.svg";